const getLocalMediaSrc = (directory, filename) => {
  if (!filename) return null;
  if (filename.startsWith('http') || filename.startsWith('/')) return filename;
  return `${directory}/${filename}`;
};

export const getFigurineImageSrc = (fig) =>
  fig?.image_url || getLocalMediaSrc('/images/figurines', fig?.image);

export const getAnimationSrc = (fig) =>
  fig?.animation_url || getLocalMediaSrc('/images/animations', fig?.animation);
